import { ComponentPropsWithoutRef } from 'react';

export function Ol(props: ComponentPropsWithoutRef<'ol'>) {
  return <ol {...props} className="list-outside list-decimal pl-24" />;
}
